import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useSecondAnalyses from 'hooks/useSecondAnalyses';
import { secondAnalysesSelectors } from "features/secondAnalyses";

const SecondAnalysesList = () => {
  const { getSecondAnalyses } = useSecondAnalyses();
  const { data, pagination } = useCustomSelector(secondAnalysesSelectors.getSecondAnalysesData);
  const fetching = useCustomSelector(secondAnalysesSelectors.secondAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getSecondAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SecondAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);